import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { company, footer, navLinks } from "../../mock";
import logo from "../../assets/logo-transparent.png";

export default function Footer() {
  return (
    <footer className="bg-navy-deep text-gray-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <img
              src={logo}
              alt="Rehabilitated For Life SSM"
              className="h-14 w-auto bg-white rounded-lg px-2 py-1.5 shadow-sm"
              data-testid="footer-logo"
            />
            <p className="mt-4 text-sm leading-relaxed text-gray-400">
              {company.division}
            </p>
          </div>

          <div>
            <h4 className="font-serif text-white font-semibold mb-4">Our Mission</h4>
            <p className="text-sm leading-relaxed text-gray-400">{footer.mission}</p>
          </div>

          <div>
            <h4 className="font-serif text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.label}>
                  {l.href.startsWith("/") ? (
                    <Link to={l.href} className="hover:text-gold transition-colors">
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} className="hover:text-gold transition-colors">
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-white font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${company.phone}`} className="flex items-center gap-2 hover:text-gold transition-colors">
                  <Phone className="h-4 w-4 text-gold" /> {company.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-gold transition-colors break-all">
                  <Mail className="h-4 w-4 text-gold" /> {company.email}
                </a>
              </li>
            </ul>
            <div className="mt-5">
              <h4 className="font-serif text-white font-semibold mb-2 text-sm">Trusted Partners</h4>
              <p className="text-xs leading-relaxed text-gray-400">{footer.partners}</p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-navy-light flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">{company.copyright}</p>
          <div className="flex gap-5 text-xs text-gray-500">
            <Link to="/terms" className="hover:text-gold transition-colors">
              Terms &amp; Conditions
            </Link>
            <Link to="/terms" className="hover:text-gold transition-colors">
              Privacy Policy
            </Link>
            <Link to="/crm/login" className="hover:text-gold transition-colors">
              Staff Portal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
